const lat = _.toNumber(app.map.marker.lat);
const lng = _.toNumber(app.map.marker.lng);

const locations = [
    [app.map.marker.label, lat, lng, 1]
];
let map = null;

const initMap = () => {
    map = new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(lat, lng),
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scrollwheel: false,
        navigationControl: false
    });
    new google.maps.InfoWindow();
    new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map
    });
};

window.onload = () => {
    initMap();
};

//if (window.global.width <= 768) {
//    $('#map').parent().appendTo($('.form-div'));
//}
